<template>
  <main id="content">
    <div class="container" style="margin-top:10px;">
      <div
        id="carouselExampleControls"
        class="carousel slide"
        data-ride="carousel"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <a
              href="https://templates-d48ff.firebaseapp.com/1/"
              target="_blank"
            >
              <img
                src="../assets/website/5.jpg"
                class="d-block w-100"
                alt="Website"
              />
            </a>
          </div>
          <div class="carousel-item">
            <a
              href="https://templates-d48ff.firebaseapp.com/2/"
              target="_blank"
            >
              <img
                src="../assets/website/9.jpg"
                class="d-block w-100"
                alt="Website"
              />
            </a>
          </div>
          <div class="carousel-item">
            <a
              href="https://templates-d48ff.firebaseapp.com/3/"
              target="_blank"
            >
              <img
                src="../assets/website/18_14V2.jpg"
                class="d-block w-100"
                alt="Website"
              />
            </a>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#carouselExampleControls"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselExampleControls"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
    <section class="container" style="padding-top:0px;">
      <div class="row text-center">
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a href="https://templates-d48ff.firebaseapp.com/2/" target="_blank">
            <div class="card">
              <img class="card-img-top" src="../assets/website/2.jpg" alt="" />
              <div class="card-footer">
                1
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a href="https://templates-d48ff.firebaseapp.com/3/" target="_blank">
            <div class="card">
              <img class="card-img-top" src="../assets/website/3.jpg" alt="" />
              <div class="card-footer">
                2
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a href="https://templates-d48ff.firebaseapp.com/4/" target="_blank">
            <div class="card">
              <img class="card-img-top" src="../assets/website/4.jpg" alt="" />
              <div class="card-footer">
                3
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a
            href="https://templates-d48ff.firebaseapp.com/5/Light"
            target="_blank"
          >
            <div class="card">
              <img class="card-img-top" src="../assets/website/5.jpg" alt="" />
              <div class="card-footer">
                4
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a
            href="https://templates-d48ff.firebaseapp.com/5/Dark"
            target="_blank"
          >
            <div class="card">
              <img
                class="card-img-top"
                src="../assets/website/5_1.jpg"
                alt=""
              />
              <div class="card-footer">
                5
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a href="https://templates-d48ff.firebaseapp.com/6/" target="_blank">
            <div class="card">
              <img class="card-img-top" src="../assets/website/6.jpg" alt="" />
              <div class="card-footer">
                6
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a href="https://templates-d48ff.firebaseapp.com/7/" target="_blank">
            <div class="card">
              <img class="card-img-top" src="../assets/website/7.jpg" alt="" />
              <div class="card-footer">
                7
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a href="https://templates-d48ff.firebaseapp.com/8/" target="_blank">
            <div class="card">
              <img class="card-img-top" src="../assets/website/8.jpg" alt="" />
              <div class="card-footer">
                8
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a href="https://templates-d48ff.firebaseapp.com/9/" target="_blank">
            <div class="card">
              <img class="card-img-top" src="../assets/website/9.jpg" alt="" />
              <div class="card-footer">
                9
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a href="https://templates-d48ff.firebaseapp.com/10/" target="_blank">
            <div class="card">
              <img class="card-img-top" src="../assets/website/10.jpg" alt="" />
              <div class="card-footer">
                10
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a href="https://templates-d48ff.firebaseapp.com/11/" target="_blank">
            <div class="card">
              <img class="card-img-top" src="../assets/website/11.jpg" alt="" />
              <div class="card-footer">
                11
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a href="https://templates-d48ff.firebaseapp.com/12/" target="_blank">
            <div class="card">
              <img class="card-img-top" src="../assets/website/12.jpg" alt="" />
              <div class="card-footer">
                12
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a href="https://templates-d48ff.firebaseapp.com/13/" target="_blank">
            <div class="card">
              <img class="card-img-top" src="../assets/website/13.jpg" alt="" />
              <div class="card-footer">
                13
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a
            href="https://templates-d48ff.firebaseapp.com/14/v1/"
            target="_blank"
          >
            <div class="card">
              <img class="card-img-top" src="../assets/website/16.jpg" alt="" />
              <div class="card-footer">
                14
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a href="https://templates-d48ff.firebaseapp.com/1/" target="_blank">
            <div class="card">
              <img class="card-img-top" src="../assets/website/1.jpg" alt="" />
              <div class="card-footer">
                15
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a
            href="https://templates-d48ff.firebaseapp.com/14/v2/"
            target="_blank"
          >
            <div class="card">
              <img
                class="card-img-top"
                src="../assets/website/17_14V.jpg"
                alt=""
              />
              <div class="card-footer">
                16
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a
            href="https://templates-d48ff.firebaseapp.com/14/v3/"
            target="_blank"
          >
            <div class="card">
              <img
                class="card-img-top"
                src="../assets/website/18_14V2.jpg"
                alt=""
              />
              <div class="card-footer">
                17
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a
            href="https://templates-d48ff.firebaseapp.com/2/index_light.html"
            target="_blank"
          >
            <div class="card">
              <img class="card-img-top" src="../assets/website/19.jpg" alt="" />
              <div class="card-footer">
                18
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a
            href="https://templates-d48ff.firebaseapp.com/2/index3_light.html"
            target="_blank"
          >
            <div class="card">
              <img class="card-img-top" src="../assets/website/20.jpg" alt="" />
              <div class="card-footer">
                19
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a href="https://templates-d48ff.firebaseapp.com/13/" target="_blank">
            <div class="card">
              <img class="card-img-top" src="../assets/website/21.jpg" alt="" />
              <div class="card-footer">
                20
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4 col-md-4 mb-4" style="margin-top:50px;">
          <a
            href="https://templates-d48ff.firebaseapp.com/13/Home-2.html"
            target="_blank"
          >
            <div class="card">
              <img class="card-img-top" src="../assets/website/22.jpg" alt="" />
              <div class="card-footer">
                21
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
    <Footer />
  </main>
</template>

<script>
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Footer
  }
};
</script>

<style lang="scss" scoped>
.card-img-top {
  // width: 250px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  // text-align: center;
}
.card {
  padding: 2px;
}
</style>
